import { useCallback, useMemo } from 'react'
import { buildMoreActionsMenuItems } from './buildMoreActionsMenuItems'

export function useUserChatBubbleMoreMenu({
  onReply,
  onForward,
  onPinForEveryone,
  onDelete,
  text,
  copied,
  handleCopy,
  showDeleteAction,
}) {
  const moreActionsMenuItems = useMemo(
    () =>
      buildMoreActionsMenuItems({
        onReply,
        onForward,
        onPinForEveryone,
        onDelete,
        text,
        copied,
        showDeleteAction,
      }),
    [onReply, onForward, onPinForEveryone, onDelete, text, copied, showDeleteAction],
  )

  const handleMoreMenuItemSelect = useCallback(
    (id) => {
      switch (id) {
        case 'reply':
          onReply?.()
          break
        case 'forward':
          onForward?.()
          break
        case 'copy':
          void handleCopy()
          break
        case 'pin':
          onPinForEveryone?.()
          break
        case 'delete':
          onDelete?.()
          break
      }
    },
    [handleCopy, onReply, onForward, onPinForEveryone, onDelete],
  )

  return { moreActionsMenuItems, handleMoreMenuItemSelect }
}
